import Button from 'components/form/Button';
import CheckBox from 'components/form/CheckBox';
import Card from 'components/Layout/Card';
import { useFormikContext } from 'formik';
import React from 'react';
import { useSelector } from 'react-redux';
import { icons } from 'utils/constants';

const AddOnsDetails = ({ onBack, onNext, btnLoading }) => {
    const { values, setFieldValue, errors } = useFormikContext();

    // const toggleService = (serviceId) => {
    //     const updatedServices = values.add_on_services.services.map((service) => {
    //         if (service.id === serviceId) {
    //             return { ...service, isChecked: !service.isChecked };
    //         }
    //         return service;
    //     });
    //     setFieldValue('add_on_services', { ...values.add_on_services, services: updatedServices });
    // };

    const servicesArray =
        Array.isArray(values?.add_on_services)
            ? values.add_on_services
            : values.add_on_services?.services || [];

    const toggleService = (serviceId) => {
        const updatedServices = servicesArray?.map((service) =>
            service.id === serviceId
                ? { ...service, isChecked: !service.isChecked }
                : service
        );

        if (Array.isArray(values.add_on_services)) {
            setFieldValue('add_on_services', updatedServices);
        } else {
            setFieldValue('add_on_services', {
                ...values.add_on_services,
                services: updatedServices,
            });
        }
    };

    return (
        <Card className="cp-20">
            <div className="text-16-500 color-1717 cmb-20">Add-Ons Details</div>
            <div className="border-bottom cmb-20 color-d1d1"></div>

            <div className="d-flex flex-wrap align-items-center gap-3">
                <div className="flex-shrink-0">
                    <img
                        src={icons.AddOnsDetails}
                        alt="AI Powered"
                        className="img-fluid"
                        style={{ maxWidth: '55px', height: 'auto' }}
                    />
                </div>
                <div className="flex-grow-1">
                    <div className="text-20-500-25">Smart Add-On Recommendations</div>
                    <div className="14-400-18 color-black-olive mt-2">
                        Based on your abstract submission, we recommend these services to enhance your research journey:
                    </div>
                </div>
            </div>

            <div className="text-16-500-20 color-title-navy cmt-20">
                Your paper deserves the best possible submission. Select the support you’d like, and our author services experts will follow up with personalized details – no automated pricing, no pressure
            </div>

            <div className="cmt-20">
                <div className="row g-3">
                    {servicesArray?.map((service) => {
                        const selected = service?.isChecked;
                        return (
                            <div id={service.id} key={service.id} className="col-6">
                                <div
                                    onClick={() => toggleService(service.id)}
                                    className={`cp-24 hover:shadow-lg transition-shadow duration-300 br-5 ${selected ? 'b-new-car bg-eff3' : 'b-d1d1'
                                        }`}
                                    style={{ minHeight: '200px', cursor: 'pointer' }}
                                >
                                    <div className="d-flex align-items-center mb-2">
                                        <h3 className={`${selected ? 'color-new-car' : 'color-dark-gray'} text-16-500-20`}>
                                            {service.service_name}
                                        </h3>
                                    </div>
                                    <p className={`${selected ? 'color-new-car' : ''} text-14-300-24`}>
                                        {service?.description || service?.service_description}
                                    </p>
                                    <div className="mt-2 d-flex align-items-center gap-2">
                                        <CheckBox type="PRIMARY-ACTIVE" isChecked={selected} />
                                        <span className={`${selected ? 'color-new-car' : ''} text-14-300-24`}>
                                            {service.checkbox_text}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        );
                    }) || null}
                </div>

                {errors.add_on_services && (
                    <div className="text-red-500 text-sm mt-1">{errors.add_on_services}</div>
                )}
            </div>

            <div className='text-12-400-15 cmt-20'>
                * Our team will review your paper & share the pricing with you shortly.
            </div>

            <div className="d-flex gap-3 cmt-20">
                {onBack && (
                    <Button
                        id="btn_add_on_back"
                        text="Back"
                        btnStyle="light-outline"
                        className="cps-40 cpe-40 h-38"
                        onClick={onBack}
                        disabled={btnLoading}
                    />
                )}
                <Button
                    id="btn_add_on_submit"
                    text="Save & Proceed"
                    btnStyle="primary-dark"
                    className="cps-40 cpe-40 h-38"
                    onClick={onNext}
                    btnLoading={btnLoading}
                    disabled={btnLoading}
                // disabled={!(values.add_on_services?.services.some(s => s.isChecked)) || btnLoading}

                />
            </div>
        </Card>
    );
};

export default AddOnsDetails;
